import { Link, Tooltip } from "@material-ui/core";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import { IconActivityDefault } from "icons/mechanicals";
import { useHistory } from "react-router-dom";
import { issueTrackerLinkedWorkOrderStyles } from "./IssueTrackerLinkedWorkOrderStyles";

const IssueTrackerLinkedWorkOrder = ({ linkedWorkOrders, onOpenWorkOrder }) => {
    const classes = issueTrackerLinkedWorkOrderStyles();
    const history = useHistory();

    if (!linkedWorkOrders?.length) {
        return null;
    }

    const openWorkOrder = (id) => {
        if (onOpenWorkOrder) {
            onOpenWorkOrder(id);
            return;
        }
        history.push(`/workorder/${id}`);
    };

    return (
        <div className={classes.row}>
            <span className={classes.label}>{linkedWorkOrders.length > 1 ? 'Linked Work Orders:' : 'Linked Work Order:'}</span>
            {linkedWorkOrders.map(workOrder =>
                <Tooltip key={workOrder.id} title="Open work order">
                    <Link
                        component="button"
                        type="button"
                        underline="none"
                        className={classes.pill}
                        aria-label={`Open work order ${workOrder.id}`}
                        onClick={() => openWorkOrder(workOrder.id)}
                    >
                        <IconActivityDefault width={15} height={15} />
                        <span>{workOrder.id}</span>
                        <OpenInNewIcon className={classes.pillIcon} />
                    </Link>
                </Tooltip>
            )}
        </div>
    );
};

export default IssueTrackerLinkedWorkOrder;
